import { FilterItem } from '@wconcept/wconcept-common/models/renewal/common';
import Box from '@wconcept/wconcept-ui-renewal/components/atoms/Box';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import FltChkItem from '@wconcept/wconcept-ui-renewal/components/molecules/_item/FltChkItem';
import FltDptCategoryItem from '@wconcept/wconcept-ui-renewal/components/molecules/_item/FltDptCategoryItem';
import FltRecCategoryItem from '@wconcept/wconcept-ui-renewal/components/molecules/_item/FltRecCategoryItem';
import { useCallback, useMemo } from 'react';
import FltDptCategoryList from '../../_list/FltDptCategoryList';
import FltRecCategoryList from '../../_list/FltRecCategoryList';

function CategoryContent({
  selectedFilters,
  recCategory,
  category,
  rootCategory,
  isItemSelected,
  handleCateegoryPathClick,
  onChangeCategory,
  noListMsg,
  hideFilterOptionCounts,
}: {
  selectedFilters: FilterItem[];
  recCategory?: FilterItem[];
  category?: FilterItem[];
  rootCategory?: FilterItem[];
  isItemSelected: (type: string, item: FilterItem) => boolean;
  handleCateegoryPathClick: (item: FilterItem) => void;
  onChangeCategory: (color: FilterItem) => void;
  noListMsg?: React.ReactNode;
  hideFilterOptionCounts?: boolean;
}) {
  const selectedCategory = useMemo(
    () => selectedFilters.filter(v => v.filterType === 'category'),
    [selectedFilters]
  );

  const mcds = useMemo(
    () => selectedCategory.filter(v => v.code?.toLowerCase().startsWith('m')),
    [selectedCategory]
  );

  const ccds = useMemo(
    () => selectedCategory.filter(v => v.code?.endsWith('000000')),
    [selectedCategory]
  );

  const pcds = useMemo(
    () =>
      selectedCategory.filter(
        v => !v.code?.endsWith('000000') && v.code?.endsWith('000')
      ),
    [selectedCategory]
  );

  const lcds = useMemo(
    () =>
      selectedCategory.filter(
        v =>
          v.code !== mcds?.[0]?.code &&
          v.code !== ccds?.[0]?.code &&
          v.code !== pcds?.[0]?.code
      ),
    [selectedCategory, mcds, ccds, pcds]
  );

  const getFltCatePath = () => {
    // 카테고리 path 데이터 가지고 버튼배열 생성
    if (rootCategory && rootCategory?.length > 0) {
      const tmp = rootCategory?.map(v => ({
        label: (
          <Button
            onClick={() => {
              handleCateegoryPathClick(v);
            }}
          >
            {v.name}
          </Button>
        ),
      }));

      // 전체 버튼 맨앞으로 추가
      tmp.unshift({
        label: (
          <Button
            onClick={() => {
              handleCateegoryPathClick({
                code: 'all',
                name: '전체',
                count: 0,
                subCode: '',
              });
            }}
          >
            전체
          </Button>
        ),
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return tmp;
    }
    return [];
  };

  const renderCateogryItem = useCallback(() => {
    const lcdsItems = lcds
      .filter(v => !category?.some(c => c.code === v.code))
      .map(v => ({
        ...v,
        count: 0,
      }));
    const allItems = [...lcdsItems, ...(category || [])];

    // 3뎁스 이상이면 체크박스로 노출
    if (pcds && pcds?.length > 0) {
      return allItems?.map((v, i) => (
        <FltChkItem
          // eslint-disable-next-line react/no-array-index-key
          key={`${v.code}_${v.name}_${i}`}
          value={v.code}
          checked={isItemSelected('category', v)}
          name={v.name}
          cnt={hideFilterOptionCounts ? undefined : v.count}
          onChange={() => {
            onChangeCategory(v);
          }}
        />
      ));
    }
    // 2뎁스 이하면 버튼으로 노출
    return allItems?.map(v => (
      <FltDptCategoryItem
        key={`${v.code}_${v.name}`}
        text={v.name}
        cnt={hideFilterOptionCounts ? undefined : v.count}
        onClick={() => onChangeCategory(v)}
      />
    ));
  }, [
    category,
    hideFilterOptionCounts,
    isItemSelected,
    onChangeCategory,
    lcds,
    pcds,
  ]);

  const renderNoListMsg = useMemo(() => {
    // 데이터가 있으면 리스트 그려준다.
    // 데이터가 없고 선택한 카테고리가 없으면 렌더링 안함
    // 3뎁스(pcds)인데 선택한 3뎁스가 없으면 -> 전체 뎁스에서 없으면 빈창대신 안내문구 출력
    if (
      // pcds &&
      // pcds?.length > 0 &&
      (!category || category?.length === 0) &&
      lcds.length === 0
    ) {
      return noListMsg;
    }
    return null;
  }, [noListMsg, category, lcds]);

  return (
    <Box className="coner-cate">
      {recCategory && recCategory?.length > 0 && (
        <FltRecCategoryList
          items={recCategory?.map(v => (
            <FltRecCategoryItem
              key={v.code}
              cnt={hideFilterOptionCounts ? undefined : v.count}
              onClick={() => onChangeCategory(v)}
            />
          ))}
        />
      )}
      <FltDptCategoryList
        catePath={getFltCatePath()} // You might need to implement this based on your data structure
        items={renderCateogryItem()}
      />
      {renderNoListMsg}
    </Box>
  );
}

export default CategoryContent;
